/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../lib/@waca/dashboard-common/dist/core/Model',
	'underscore'
], (Model, _) => {
	const CustomColorsModel = Model.extend({
		whitelistAttrs: ['colors'],
		init: function (model) {
			if (model) {
				_.defaults(model, {
					colors: []
				});
			}

			CustomColorsModel.inherited('init', this, arguments);
		},

		addCustomColor: function (colorsToAdd) {
			const colors = Array.isArray(colorsToAdd) ? colorsToAdd : [colorsToAdd];
			let colorAdded = false;

			colors.forEach(color => {
				let lowerCaseHexIndex = this.colors.indexOf(color.toLowerCase());
				let upperCaseHexIndex = this.colors.indexOf(color.toUpperCase());

				if (lowerCaseHexIndex === -1 && upperCaseHexIndex === -1) {
					this.colors.push(color);
					colorAdded = true;
				}
			});

			if (colorAdded) {
				this.trigger('changed:colors', {
					payloadData: {
						skipUndoRedo: true
					},
					data: { runtimeOnly: true }
				});
			}
		},

		getHexColorFromClassName: function(className) {
			return '#' + className.split('customColor')[1];
		},

		customColorExists: function(color) {
			return this.colors.indexOf(color);
		},

		isCustomColor: function (color) {
			if (!color) {
				return false;
			}
			return color.indexOf('customColor') !== -1;
		},

		getColorClassName: function (color) {
			if (!color) {
				return '';
			}
			const colorNum = color.indexOf('#') === 0 ? color.substring(1) : color;
			return `customColor${colorNum}`;
		},

		getCustomPaletteDefinition: function () {
			const ids = [];
			this.colors.forEach((color) => {
				ids.push(this.getColorClassName(color));
			});
			return {
				id: 'customColorPalette',
				ids: ids,
				fillType: 'simple',
				fills: this.colors
			};
		}
	});

	return CustomColorsModel;
});
